export default [
    {
        name: 'projectList',
        path: '/project/list',
        component: require('@/pages/ProjectList').default,
        meta: {
            crumbs: [],
            security: (auth) => auth.can({ action: 'list', model: 'project' })
        }
    },
    {
        name: 'projectCreate',
        path: '/project/create',
        component: require('@/pages/ProjectCreate').default,
        meta: {
            back: { label: 'Project List', to: '/project/list' },
            security: (auth) => auth.can({ action: 'create', model: 'project' })
        }
    },
    {
        name: 'projectCreateAgency',
        path: '/project/create/agencyId/:agencyId',
        props: (route) => ({
            agencyId: +route.params.agencyId,
        }),
        component: require('@/pages/ProjectCreate').default,
        meta: {
            back: { label: 'Project List', to: '/project/list' },
            security: (auth) => auth.can({ action: 'create', model: 'project' })
        }
    },
    {
        name: 'projectView',
        path: '/project/view/:projectId',
        component: require('@/pages/ProjectView').default,
        props: (route) => ({
            projectId: +route.params.projectId,
        }),
        meta: {
            back: { label: 'Project List', to: '/project/list' },
            security: (auth) => auth.can({
                action: 'view',
                model: 'project',
                arg: +auth.to.params.projectId
            })
        }
    },
    {
        name: 'projectEdit',
        path: '/project/edit/:projectId',
        component: require('@/pages/ProjectEdit').default,
        props: (route) => ({
            projectId: +route.params.projectId,
        }),
        meta: {
            back: { label: ':projectName', to: '/project/view/:projectId' },
            security: (auth) => auth.can({
                action: 'edit',
                model: 'project',
                arg: +auth.to.params.projectId
            })
        }
    },
    {
        path: '/project/addsub/:projectId',
        component: require('@/pages/ProjectAddSub').default,
        props: (route) => ({
            projectId: +route.params.projectId,
        }),
        meta: {
            back: { label: ':projectName', to: '/project/view/:projectId' },
            security: (auth) => auth.can({
                action: 'add-subcontractors',
                model: 'project',
                arg: +auth.to.params.projectId
            })
        }
    }
]
